module.exports = __webpack_public_path__ + "img/happy_clients_bw.f64729e.png";